/* eslint-disable react-hooks/exhaustive-deps */
import ReactLoading from 'react-loading';
import Cookies from 'js-cookie';
import SideBar from './SideBar';
import IconButton from '@material-ui/core/IconButton';
import api from 'api';
import CommissionSlider from './CommissionSlider';
import { Select } from 'components';
import { useEffect, useRef, useState } from 'react';
import { Container } from '../../style';
import { Content, OptionsSide, VehicleDataSide, CoveragesArea, ExclusiveLabel, ProductsList, ComboDescription } from './style';
import { formatFipeId } from 'utils/vehicleType';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { getCurrentSubdomain } from 'utils/general';
import { FiCheck, FiTrash } from 'react-icons/fi';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import { getCommissionPayloadValue, getInitialCommissionValue, shouldUseAbsoluteCommission } from './commission';

const COMBO_ONLY_PARTNER_ID = 55;

export const CoverageStep = ({
  quotationData,
  setQuotationData,
  quotationResponse,
  nextStep,
  percentCommission,
  setPercentCommission,
  percentDiscount,
  setPercentDiscount,
  sliderHandle,
  setSliderHandle,
  dataCoverage,
  setDataCoverage,
  proposalResponse,
  setQuotationResponse,
  products,
  selectedProducts,
  setSelectedProducts,
  handleProducts,
  getPartnerProducts,
}) => {
  const [loading, setLoading] = useState(false);
  const [hasChange, setHasChange] = useState(false);
  const [exclusive, setExclusive] = useState(false);
  const [basicCoverages, setBasicCoverages] = useState([]);
  const [coverageCombos, setCoverageCombos] = useState([]);
  const [policyModalitiesOptions, setPolicyModalitiesOptions] = useState([{ value: 'monthly', label: 'Mensal' }]);
  const [policyModalitiesLoading, setPolicyModalitiesLoading] = useState(true);
  const [installments, setInstallments] = useState('');
  const [installmentOptions, setInstallmentOptions] = useState([]);
  const [installmentOptionsLoading, setInstallmentOptionsLoading] = useState(false);
  const [installmentOptionsError, setInstallmentOptionsError] = useState(false);
  const [installmentOptionsQuoteTotal, setInstallmentOptionsQuoteTotal] = useState(null);
  const [quotationCalculationState, setQuotationCalculationState] = useState({ loading: false, error: false });
  const installmentOptionsRequestId = useRef(0);

  const selectedPolicyModality = policyModalitiesOptions.find((option) => option.value === quotationData?.policy_modality);
  const shouldUseAnnualInstallments =
    quotationData?.policy_modality === 'annual' && selectedPolicyModality?.installmentsEnabled === true;
  const shouldFetchInstallmentOptions = shouldUseAnnualInstallments;
  const showInstallmentSelect = shouldUseAnnualInstallments;
  const quotationTotal = Number(quotationResponse?.total);
  const hasValidQuotationTotal = Number.isFinite(quotationTotal) && quotationTotal > 0;
  const installmentOptionsAreCurrent = hasValidQuotationTotal && installmentOptionsQuoteTotal === quotationTotal;
  const selectedInstallmentOption =
    installmentOptionsAreCurrent && !installmentOptionsError
      ? installmentOptions.find((i) => i.installments === installments)
      : undefined;
  const installmentSelectLoading =
    !quotationCalculationState.error &&
    !installmentOptionsError &&
    (quotationCalculationState.loading || installmentOptionsLoading || !hasValidQuotationTotal || !installmentOptionsAreCurrent);
  const installmentSelectDisabled =
    installmentSelectLoading || quotationCalculationState.error || installmentOptionsError || installmentOptions.length === 0;
  const useRangeSlider = shouldUseAbsoluteCommission(getCurrentSubdomain(), sliderHandle);
  const effectiveGrievancePercent = getCommissionPayloadValue({
    percentCommission,
    grievancePercent: sliderHandle?.grievance_percent,
    minGrievancePercent: sliderHandle?.min_grievance_percent,
    maxGrievancePercent: sliderHandle?.max_grievance_percent,
    useAbsoluteCommission: useRangeSlider,
  });

  const formatCurrencyValue = (value) =>
    Number(value || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  const [supportCoverages, setSupportCoverages] = useState([]);
  const [replacementCoverages, setReplacementCoverages] = useState([]);
  const [glassCoverages, setGlassCoverages] = useState([]);
  const [optionalCoverages, setOptionalCoverages] = useState([]);
  const [lmiCoverages, setLmiCoverages] = useState([]);
  const [deductibleCoverages, setDeductibleCoverages] = useState([]);

  const selectedCoverageCombo = coverageCombos.find((item) => item.id === dataCoverage?.id_coverage_combo);
  const hasSelectedCoverageCombo = Boolean(selectedCoverageCombo);
  const loggedUser = jwtDecode(Cookies.get('splitriskwl-authtoken'));
  const isComboOnlyPartner = loggedUser?.id_partner === COMBO_ONLY_PARTNER_ID;
  const requiresBasicCoverage = sliderHandle?.capabilities?.requiresBasicCoverage !== false;

  const getCoverageSelectValue = (value) => (hasSelectedCoverageCombo ? 'Selecione' : value);

  const getComboDescriptionItems = (combo) => {
    const includedCoverageNames = combo?.includedCoverages?.map((coverage) => coverage?.name).filter(Boolean);
    if (includedCoverageNames?.length) return includedCoverageNames;
    if (!combo?.description) return [];

    return combo.description.split(' + ').filter(Boolean);
  };
  const selectedCoverageComboDescriptionItems = getComboDescriptionItems(selectedCoverageCombo);

  const [toogleSections, setToogleSections] = useState({
    basic: true,
    additional: true,
    optional: true,
    discount: true,
    modality: true,
    product: true,
  });
  const getOptionalCoverageKey = (type) => {
    if (type === 'accessories_motorcycle') return 'accessoriesMotorcycle';
    return type;
  };

  const buildOptionalCoveragesByIds = (ids = [], availableOptionalCoverages = optionalCoverages) => {
    return ids.reduce((acc, id) => {
      const coverage = availableOptionalCoverages?.find((item) => item.id === id);
      const key = getOptionalCoverageKey(coverage?.type);

      if (key) acc[key] = id;

      return acc;
    }, {});
  };

  const buildCoverageDataFromCombo = (combo, availableOptionalCoverages = optionalCoverages) => ({
    id_coverage_combo: combo.id,
    id_basic_coverage: combo.id_basic_coverage || undefined,
    id_support_coverage: combo.id_support_coverage || undefined,
    id_replacement_car_coverage: combo.id_replacement_car_coverage || undefined,
    id_glass_coverage: combo.id_glass_coverage || undefined,
    id_fipe_lmi_coverage: combo.id_fipe_lmi_coverage || undefined,
    id_deductible_coverage: combo.id_deductible_coverage || undefined,
    optional_coverages: buildOptionalCoveragesByIds(combo.optional_coverages, availableOptionalCoverages),
  });

  const findMatchingCoverageCombo = (coverageData, combos = coverageCombos) => {
    const optionals = coverageData?.optionals || [];

    return combos.find((combo) => {
      const comboOptionals = combo.optional_coverages || [];
      const sameOptionals = comboOptionals.length === optionals.length && comboOptionals.every((id) => optionals.includes(id));

      return (
        combo.id_basic_coverage === coverageData?.id_basic_coverage &&
        combo.id_support_coverage === coverageData?.id_support_coverage &&
        (combo.id_replacement_car_coverage || undefined) === coverageData?.id_replacement_car_coverage &&
        (combo.id_glass_coverage || undefined) === coverageData?.id_glass_coverage &&
        (combo.id_fipe_lmi_coverage || undefined) === coverageData?.id_fipe_lmi_coverage &&
        (combo.id_deductible_coverage || undefined) === coverageData?.id_deductible_coverage &&
        sameOptionals
      );
    });
  };

  const handleCoverageCombo = async (value) => {
    if (value === 'Selecione') {
      setExclusive(false);
      setDataCoverage({});
      return;
    }

    const combo = coverageCombos.find((item) => item.id === Number(value));
    if (!combo) return;

    const basicCoverage = basicCoverages.find((item) => item.id === combo.id_basic_coverage);
    setExclusive(Boolean(basicCoverage?.exclusive));
    setDataCoverage(buildCoverageDataFromCombo(combo));
    await getOptionalCoverages(Boolean(basicCoverage?.exclusive));
    await getDeductibleCoverages(Boolean(basicCoverage?.exclusive));
  };

  const getOptionalCoverages = async (exclusive) => {
    const resp = await api({
      method: 'post',
      url: `/quotation/get-optional-coverage`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      data: {
        type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
        value: quotationData?.vehicle?.value,
        zero_km: quotationData?.vehicle?.zero_km,
        exclusive,
      },
    });
    if (exclusive || quotationData?.vehicle?.zero_km) {
      setDataCoverage((prev) => ({
        ...prev,
        optional_coverages: {
          ...prev?.optional_coverages,
          workshop: undefined,
        },
      }));
    }
    setOptionalCoverages(resp?.data);
  };
  const getDeductibleCoverages = async (exclusive) => {
    const resp = await api({
      method: 'post',
      url: `/quotation/get-deductible-coverage`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      data: {
        type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
        value: quotationData?.vehicle?.value,
        zero_km: quotationData?.vehicle?.zero_km,
        exclusive,
      },
    });
    if (exclusive) {
      setDataCoverage((prev) => ({
        ...prev,
        id_deductible_coverage: undefined,
      }));
    }
    setDeductibleCoverages(resp?.data);
  };

  const handleOptionalAndBasic = async (value) => {
    setDataCoverage((prev) => ({
      ...prev,
      id_coverage_combo: undefined,
      id_basic_coverage: value === 'Selecione' ? undefined : Number(value),
    }));

    for (const i of basicCoverages) {
      if (i.exclusive && Number(value) === i.id) {
        setExclusive(true);
        await getOptionalCoverages(true);
        await getDeductibleCoverages(true);
        break;
      } else {
        setExclusive(false);
        await getOptionalCoverages(false);
        await getDeductibleCoverages(false);
      }
    }
  };
  const loadData = async () => {
    setLoading(true);
    try {
      const promises = [
        api({
          method: 'post',
          url: `/quotation/get-basic-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            brand: quotationData?.vehicle?.id_brand,
            fipe_code: quotationData?.vehicle?.fipe_code,
            value: quotationData?.vehicle?.value,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-support-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-replacement-car-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-glass-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-optional-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
            zero_km: quotationData?.vehicle?.zero_km,
            exclusive: false,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-fipe-lmi-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
            from_auction: quotationData?.vehicle?.auction || quotationData?.vehicle?.remarked,
          },
        }),
        api({
          method: 'post',
          url: `/quotation/get-deductible-coverage`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          data: {
            type_vehicle: formatFipeId(quotationData?.vehicle?.id_type || quotationData?.vehicle?.id_vehicle_type),
            value: quotationData?.vehicle?.value,
            exclusive: false,
          },
        }),
        api({
          method: 'get',
          url: `/quotation/coverage-combos`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
        }),
      ];
      let filteredObject = undefined;
      if (quotationData?.quotationProposalData?.quotationProposalId) {
        const quotation = await api({
          method: 'get',
          url: `/quotation/proposal/${quotationData?.quotationProposalData?.quotationProposalId}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
        });
        const response = quotation.data;
        const optionals = response?.TB_PRICING_OPTIONAL_COVERAGE_TB_QUOTATION_PROPOSAL.map((i) => {
          return i.id_pricing_optional_coverage;
        });

        const coverageData = {
          id_basic_coverage: response?.TB_PRICING_BASIC_COVERAGE_TB_QUOTATION_PROPOSAL[0]?.id_pricing_basic_coverage,
          id_support_coverage: response?.TB_PRICING_SUPPORT_TB_QUOTATION_PROPOSAL[0]?.id_pricing_support,
          id_replacement_car_coverage: response?.TB_PRICING_REPLACEMENT_CAR_TB_QUOTATION_PROPOSAL[0]?.id_pricing_replacement_car,
          id_glass_coverage: response?.TB_PRICING_GLASS_TB_QUOTATION_PROPOSAL[0]?.id_pricing_glass,
          id_fipe_lmi_coverage: response?.TB_PRICING_FIPE_LMI_TB_QUOTATION_PROPOSAL[0]?.id_pricing_fipe_lmi,
          id_deductible_coverage: response?.TB_PRICING_DEDUCTIBLE_TB_QUOTATION_PROPOSAL[0]?.id_pricing_deductible,
          optionals,
          discount: response.discount_percent,
          commission: response.grievance_percent,
        };
        if (response?.policy_modality) {
          setQuotationData((prev) => ({ ...prev, policy_modality: response.policy_modality }));
        }
        if (response?.installments) {
          setInstallments(response.installments);
        }
        filteredObject = Object.fromEntries(Object.entries(coverageData).filter(([key, value]) => value !== undefined));

        setDataCoverage(filteredObject);
      }
      const responses = await Promise.all(promises);

      const [basicResp, supportResp, replacementResp, glassResp, optionalResp, lmiResp, deductibleResp, combosResp] = responses;
      // console.log(filteredObject, 'iiii');
      for (const item of basicResp?.data) {
        if (item.id === filteredObject?.id_basic_coverage && item.exclusive) {
          setExclusive(true);
          continue;
        }
      }
      setBasicCoverages(basicResp?.data);
      setSupportCoverages(supportResp?.data);
      setReplacementCoverages(replacementResp?.data);
      setGlassCoverages(glassResp?.data);
      setOptionalCoverages(optionalResp?.data);
      setLmiCoverages(lmiResp?.data);
      setDeductibleCoverages(deductibleResp?.data);
      setCoverageCombos(combosResp?.data || []);

      const damagesToThirdParties = optionalResp.data?.filter((i) => i.type === 'damages_to_third_parties');
      const app = optionalResp.data?.filter((i) => i.type === 'app');
      const workshop = optionalResp.data?.filter((i) => i.type === 'workshop');
      const accessoriesCar = optionalResp.data?.filter((i) => i.type === 'accessories_car');
      const accessoriesMotorcycle = optionalResp.data?.filter((i) => i.type === 'accessories_motorcycle');
      const gasKit = optionalResp.data?.filter((i) => i.type === 'gas_kit');
      const extraordinaryEexpenses = optionalResp.data?.filter((i) => i.type === 'extraordinary_expenses');
      const damagesCorporais = optionalResp.data?.filter((i) => i.type === 'damages_corporais');
      const damagesMorais = optionalResp.data?.filter((i) => i.type === 'damages_morais');
      const matchingCombo = filteredObject ? findMatchingCoverageCombo(filteredObject, combosResp?.data || []) : null;

      if (matchingCombo) {
        setDataCoverage(buildCoverageDataFromCombo(matchingCombo, optionalResp.data));
      } else if (filteredObject) {
        for (const item of damagesToThirdParties) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, damages_to_third_parties: item.id },
            }));
            break;
          }
        }
        for (const item of app) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, app: item.id },
            }));
            break;
          }
        }
        for (const item of workshop) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, workshop: item.id },
            }));
            break;
          }
        }
        for (const item of accessoriesCar) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, accessories_car: item.id },
            }));
            break;
          }
        }
        for (const item of accessoriesMotorcycle) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, accessoriesMotorcycle: item.id },
            }));
            break;
          }
        }
        // for (const item of gasKit) {
        //   if (filteredObject?.optionals?.includes(item.id)) {
        //     setDataCoverage((prev) => ({
        //       ...prev,
        //       optional_coverages: { ...prev?.optional_coverages, gas_kit: item.id },
        //     }));
        //     break;
        //   }
        // }
        for (const item of extraordinaryEexpenses) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, extraordinary_expenses: item.id },
            }));
            break;
          }
        }
        for (const item of damagesCorporais) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, damages_corporais: item.id },
            }));
            break;
          }
        }
        for (const item of damagesMorais) {
          if (filteredObject?.optionals?.includes(item.id)) {
            setDataCoverage((prev) => ({
              ...prev,
              optional_coverages: { ...prev?.optional_coverages, damages_morais: item.id },
            }));
            break;
          }
        }
      }

      const slider = await api({
        method: 'get',
        url: 'quotation/commission',
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
      });
      setSliderHandle({ ...slider.data });

      const enabledRangeSlider = shouldUseAbsoluteCommission(getCurrentSubdomain(), slider.data);
      const loadedCommission = filteredObject?.commission ?? dataCoverage?.commission;

      if (!slider.data.handle && !enabledRangeSlider) {
        setPercentCommission(100);
      } else {
        setPercentCommission(getInitialCommissionValue(slider.data, loadedCommission, enabledRangeSlider));
      }
      //dont change, dont make comments too, i'm wrong
      // if (!slider.data.handle) {
      //   setPercentCommission(100);
      // } else {
      //   setPercentCommission(dataCoverage.commission ? (dataCoverage.commission * 100) / slider.data.grievance_percent : 0);
      //   setPercentDiscount(dataCoverage.discount ? (dataCoverage.discount * 100) / slider.data.discount_percent : 0);
      // }
      setLoading(false);
      setHasChange(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao carregar dados da cotação', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    console.log(dataCoverage);
  };

  const getAvailablePolicyModalities = async () => {
    setPolicyModalitiesLoading(true);
    try {
      const resp = await api({
        method: 'GET',
        url: `quotation/get-modality-options/${quotationData?.quotationProposalData?.quotationProposalId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
        json: true,
      });
      if (resp.data.length > 0) {
        const availableOptions = resp.data;

        setPolicyModalitiesOptions(availableOptions);
        if (availableOptions.length === 1) {
          setQuotationData((prev) => ({ ...prev, policy_modality: availableOptions[0].value }));
        }
      }
    } catch (error) {
    } finally {
      setPolicyModalitiesLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    setHasChange(false);
  }, []);

  useEffect(() => {
    if (!loading && products?.length > 0 && dataCoverage?.id_basic_coverage) {
      const automaticProducts = products.filter((product) => product.applied_automatic);
      if (automaticProducts.length > 0) {
        setSelectedProducts((prev) => {
          const newProducts = [...prev];
          automaticProducts.forEach((product) => {
            if (!newProducts.find((p) => p.id === product.id)) {
              newProducts.push(product);
            }
          });
          return newProducts;
        });
      }
    }
  }, [loading, dataCoverage?.id_basic_coverage]);

  useEffect(() => {
    if (dataCoverage?.id_basic_coverage && !dataCoverage?.id_coverage_combo) {
      handleOptionalAndBasic(dataCoverage?.id_basic_coverage);
    }
    getAvailablePolicyModalities();
  }, [basicCoverages]);
  useEffect(() => {
    setHasChange(true);
  }, [dataCoverage, percentDiscount, percentCommission, quotationData.policy_modality, selectedProducts, installments]);

  useEffect(() => {
    setQuotationData((prev) => ({
      ...prev,
      installments: shouldUseAnnualInstallments && installments ? installments : undefined,
    }));
  }, [installments, shouldUseAnnualInstallments]);

  useEffect(() => {
    const fetchInstallmentOptions = async () => {
      const requestId = ++installmentOptionsRequestId.current;
      const quotationProposalId = quotationData?.quotationProposalData?.quotationProposalId;

      if (!shouldFetchInstallmentOptions) {
        setInstallmentOptions([]);
        setInstallmentOptionsQuoteTotal(null);
        setInstallmentOptionsLoading(false);
        setInstallmentOptionsError(false);
        return;
      }

      if (
        !quotationProposalId ||
        !hasValidQuotationTotal ||
        quotationCalculationState.loading ||
        quotationCalculationState.error
      ) {
        setInstallmentOptionsLoading(false);
        if (quotationCalculationState.loading) setInstallmentOptionsError(false);
        return;
      }

      setInstallmentOptionsLoading(true);
      setInstallmentOptionsError(false);
      try {
        const resp = await api({
          method: 'GET',
          url: `quotation/installment-options/${quotationProposalId}`,
          params: {
            policyModality: quotationData?.policy_modality,
            monthlyValue: quotationTotal,
            grievance_percent: effectiveGrievancePercent,
            base_grievance_percent: effectiveGrievancePercent,
          },
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
        });

        if (requestId !== installmentOptionsRequestId.current) return;

        const options = resp?.data || [];
        setInstallmentOptions(options);
        setInstallmentOptionsQuoteTotal(quotationTotal);
        if (options.length === 1) setInstallments(options[0].installments);
      } catch (error) {
        if (requestId !== installmentOptionsRequestId.current) return;

        console.error(error);
        setInstallmentOptionsError(true);
      } finally {
        if (requestId === installmentOptionsRequestId.current) {
          setInstallmentOptionsLoading(false);
        }
      }
    };

    fetchInstallmentOptions();

    return () => {
      installmentOptionsRequestId.current += 1;
    };
  }, [
    shouldFetchInstallmentOptions,
    quotationData?.quotationProposalData?.quotationProposalId,
    quotationData?.policy_modality,
    quotationTotal,
    quotationCalculationState.loading,
    quotationCalculationState.error,
  ]);

  return (
    <Container>
      {/* <h1>{`${hasChange}`}</h1> */}
      <Content>
        {loading && <ReactLoading color="rgb(0 176 90)" height={24} width={24} type="spin" />}
        {!loading && (
          <OptionsSide>
            {requiresBasicCoverage && (
              <h3 style={{ marginTop: 15 }}>
                {isComboOnlyPartner ? 'Combo de produtos' : 'Coberturas básicas'}
                <IconButton
                  size="small"
                  style={{ marginLeft: 10 }}
                  onClick={() => setToogleSections({ ...toogleSections, basic: !toogleSections.basic })}
                >
                  {toogleSections?.basic ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                </IconButton>
              </h3>
            )}
            {requiresBasicCoverage && toogleSections?.basic && (
              <>
                <CoveragesArea>
                  {coverageCombos?.length > 0 && (
                    <Select
                      label="Combo de produtos"
                      height="35px"
                      width="400px"
                      value={dataCoverage?.id_coverage_combo}
                      onChange={(e) => handleCoverageCombo(e.target.value)}
                    >
                      <option>Selecione</option>
                      {coverageCombos?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Select>
                  )}
                  {hasSelectedCoverageCombo && selectedCoverageComboDescriptionItems.length > 0 && (
                    <ComboDescription>
                      <strong>
                        <span className="combo-name">{selectedCoverageCombo?.name}</span>
                        <span className="combo-sub">Incluído neste combo</span>
                      </strong>
                      <ul>
                        {selectedCoverageComboDescriptionItems.map((item, index) => (
                          <li key={index}>
                            <FiCheck size={14} />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </ComboDescription>
                  )}
                  {!isComboOnlyPartner && (
                    <Select
                      label={coverageCombos?.length > 0 ? 'Cobertura básica' : undefined}
                      disableLabel={coverageCombos?.length === 0}
                      height="35px"
                      width="400px"
                      disabled={hasSelectedCoverageCombo}
                      // value={quotationData?.id_basic_coverage}
                      value={getCoverageSelectValue(dataCoverage?.id_basic_coverage)}
                      onChange={(e) => {
                        handleOptionalAndBasic(e.target.value);
                      }}
                    >
                      <option>Selecione</option>
                      {basicCoverages?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Select>
                  )}
                </CoveragesArea>
                {!isComboOnlyPartner && exclusive && (
                  <ExclusiveLabel>Coberturas EXCLUSIVAS possuem franquias quando acionadas</ExclusiveLabel>
                )}
              </>
            )}

            {dataCoverage?.id_basic_coverage || !requiresBasicCoverage ? (
              <>
                {/* MODALIDADE DE CONTRATAÇÃO */}
                {policyModalitiesOptions.length > 1 && (
                  <h3 style={{ marginTop: 15 }}>
                    Modalidade de contratação
                    <IconButton
                      size="small"
                      style={{ marginLeft: 10 }}
                      onClick={() => setToogleSections({ ...toogleSections, modality: !toogleSections.modality })}
                    >
                      {toogleSections?.modality ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                    </IconButton>
                  </h3>
                )}

                {toogleSections?.modality && (
                  <CoveragesArea style={{ marginTop: -10 }}>
                    {policyModalitiesOptions.length > 1 && (
                      <Select
                        disableLabel
                        height="35px"
                        width="400px"
                        disabled={policyModalitiesOptions?.length <= 1}
                        value={quotationData?.policy_modality}
                        onChange={async (e) => {
                          const policyModality = e.target.value;
                          const nextModalityOption = policyModalitiesOptions.find((option) => option.value === policyModality);
                          const nextShouldUseAnnualInstallments = nextModalityOption?.installmentsEnabled === true;
                          const nextQuotationData = {
                            ...quotationData,
                            ...dataCoverage,
                            optionalCoverages: dataCoverage?.optional_coverages,
                            policy_modality: policyModality,
                            grievance_percent: effectiveGrievancePercent,
                            installments: nextShouldUseAnnualInstallments && installments ? installments : undefined,
                          };

                          setQuotationData(nextQuotationData);
                          await handleOptionalAndBasic(dataCoverage?.id_basic_coverage);
                        }}
                      >
                        {policyModalitiesOptions?.map((item, index) => (
                          <option key={index} value={item?.value}>
                            {item?.label}
                          </option>
                        ))}
                      </Select>
                    )}

                    {shouldFetchInstallmentOptions && showInstallmentSelect && (
                      <div style={{ marginTop: 15 }}>
                        <h4 style={{ marginBottom: 8, fontSize: 14 }}>Parcelamento do plano anual</h4>
                        <Select
                          disableLabel
                          height="35px"
                          width="400px"
                          disabled={installmentSelectDisabled}
                          value={installmentSelectDisabled ? '' : installments}
                          onChange={(e) => setInstallments(e.target.value ? Number(e.target.value) : '')}
                        >
                          {installmentSelectLoading && <option value="">Calculando valores...</option>}
                          {!installmentSelectLoading && quotationCalculationState.error && (
                            <option value="">Não foi possível calcular os valores</option>
                          )}
                          {!installmentSelectLoading && !quotationCalculationState.error && installmentOptionsError && (
                            <option value="">Não foi possível carregar as parcelas</option>
                          )}
                          {!installmentSelectLoading &&
                            !quotationCalculationState.error &&
                            !installmentOptionsError &&
                            installmentOptions.length === 0 && <option value="">Parcelamento indisponível</option>}
                          {!installmentSelectDisabled && (
                            <>
                              <option value="">Selecione a quantidade de parcelas</option>
                              {installmentOptions.map((item, index) => (
                                <option key={index} value={item?.installments}>
                                  {item?.installments}x {formatCurrencyValue(item?.installmentValue)}
                                </option>
                              ))}
                            </>
                          )}
                        </Select>
                      </div>
                    )}
                  </CoveragesArea>
                )}

                {!isComboOnlyPartner && requiresBasicCoverage && (
                  <h3 style={{ marginTop: 15 }}>
                    Coberturas adicionais
                    <IconButton
                      size="small"
                      style={{ marginLeft: 10 }}
                      onClick={() => setToogleSections({ ...toogleSections, additional: !toogleSections.additional })}
                    >
                      {toogleSections?.additional ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                    </IconButton>
                  </h3>
                )}

                {!isComboOnlyPartner && requiresBasicCoverage && toogleSections?.additional && (
                  <CoveragesArea style={{ marginTop: -10 }}>
                    {/* ASSIST 24h */}
                    {supportCoverages?.length > 0 && (
                      <Select
                        label="Assistência 24h"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.id_support_coverage)}
                        onChange={(e) => {
                          // setQuotationData({ ...quotationData, id_support_coverage: e.target.value === "Selecione"?undefined:Number(e.target.value) });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            id_support_coverage: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {supportCoverages?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Select>
                    )}

                    {/* CARRO RESERVA */}
                    {replacementCoverages?.length > 0 && (
                      <Select
                        label="Carro reserva"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.id_replacement_car_coverage)}
                        onChange={(e) => {
                          // setQuotationData({ ...quotationData, id_replacement_car_coverage: e.target.value === "Selecione"?undefined:Number(e.target.value) });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            id_replacement_car_coverage: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {replacementCoverages?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Select>
                    )}

                    {/* VIDROS */}
                    {glassCoverages?.length > 0 && (
                      <Select
                        label="Vidros"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.id_glass_coverage)}
                        onChange={(e) => {
                          // setQuotationData({ ...quotationData, id_glass_coverage: e.target.value === "Selecione"?undefined:Number(e.target.value) });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            id_glass_coverage: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {glassCoverages?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Select>
                    )}

                    {/* LMI */}
                    {lmiCoverages?.length > 0 && (
                      <Select
                        label="Limite máximo de indenização (LMI). Obs: Padrão LMI 100%"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.id_fipe_lmi_coverage)}
                        onChange={(e) => {
                          // setQuotationData({ ...quotationData, id_fipe_lmi_coverage: e.target.value === "Selecione"?undefined:Number(e.target.value) });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            id_fipe_lmi_coverage: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {lmiCoverages?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Select>
                    )}

                    {/* FRANQUIA REDUZIDA */}
                    {deductibleCoverages?.length > 0 && (
                      <Select
                        label="Franquia Reduzida. Obs: Padrão normal 10%"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.id_deductible_coverage)}
                        onChange={(e) => {
                          // setQuotationData({ ...quotationData, id_deductible_coverage: e.target.value === "Selecione"?undefined:Number(e.target.value) });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            id_deductible_coverage: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {deductibleCoverages?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Select>
                    )}
                  </CoveragesArea>
                )}

                {!isComboOnlyPartner && (
                  <h3 style={{ marginTop: 15 }}>
                    Coberturas opcionais
                    <IconButton
                      size="small"
                      style={{ marginLeft: 10 }}
                      onClick={() => setToogleSections({ ...toogleSections, optional: !toogleSections.optional })}
                    >
                      {toogleSections?.optional ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                    </IconButton>
                  </h3>
                )}
                {!isComboOnlyPartner && toogleSections?.optional && (
                  <CoveragesArea style={{ marginTop: -10 }}>
                    {optionalCoverages?.filter((i) => i.type === 'damages_to_third_parties')?.length > 0 && (
                      <Select
                        label="Danos a terceiros"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.damages_to_third_parties)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     damages_to_third_parties: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              damages_to_third_parties: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'damages_to_third_parties')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {/* APP - app */}
                    {optionalCoverages?.filter((i) => i.type === 'app')?.length > 0 && (
                      <Select
                        label="APP"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.app)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     app: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              app: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'app')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {/* Livre Escolha Oficina - workshop */}
                    {optionalCoverages?.filter((i) => i.type === 'workshop')?.length > 0 && (
                      <Select
                        label="Oficina"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.workshop)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     workshop: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              workshop: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'workshop')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {/* Acessórios - accessories_car */}
                    {optionalCoverages?.filter((i) => i.type === 'accessories_car')?.length > 0 && (
                      <Select
                        label="Acessórios"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.accessories_car)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     accessories_car: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              accessories_car: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'accessories_car')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {/* Kit Gas - gas_kit */}
                    {optionalCoverages?.filter((i) => i.type === 'gas_kit')?.length > 0 && quotationData?.vehicle.gnv && (
                      <Select
                        label="Kit Gás"
                        height="35px"
                        width="400px"
                        disabled={true}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.gas_kit)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     gas_kit: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                        }}
                      >
                        {/* <option>Selecione</option> */}
                        {optionalCoverages
                          ?.filter((i) => i.type === 'gas_kit')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {/* Depesas Extraordinárias - extraordinary_expenses */}
                    {optionalCoverages?.filter((i) => i.type === 'extraordinary_expenses')?.length > 0 && (
                      <Select
                        label="Depesas Extraordinárias"
                        height="35px"
                        width="400px"
                        disabled={hasSelectedCoverageCombo}
                        value={getCoverageSelectValue(dataCoverage?.optional_coverages?.extraordinary_expenses)}
                        onChange={(e) => {
                          // setQuotationData({
                          //   ...quotationData,
                          //   optionalCoverages: {
                          //     ...quotationData?.optionalCoverages,
                          //     extraordinary_expenses: Number(e.target.value === "Selecione"?undefined:Number(e.target.value)),
                          //   },
                          // });
                          setDataCoverage((prev) => ({
                            ...prev,
                            id_coverage_combo: undefined,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              extraordinary_expenses: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option value="" disabled selected>
                          Selecione
                        </option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'extraordinary_expenses')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {optionalCoverages?.filter((i) => i.type === 'damages_corporais')?.length > 0 && (
                      <Select
                        label="RCFV Danos Corporais"
                        height="35px"
                        width="400px"
                        value={dataCoverage?.optional_coverages?.damages_corporais}
                        onChange={(e) => {
                          setDataCoverage((prev) => ({
                            ...prev,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              damages_corporais: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'damages_corporais')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}

                    {optionalCoverages?.filter((i) => i.type === 'damages_morais')?.length > 0 && (
                      <Select
                        label="RCFV Danos Morais"
                        height="35px"
                        width="400px"
                        value={dataCoverage?.optional_coverages?.damages_morais}
                        onChange={(e) => {
                          setDataCoverage((prev) => ({
                            ...prev,
                            optional_coverages: {
                              ...prev?.optional_coverages,
                              damages_morais: e.target.value === 'Selecione' ? undefined : Number(e.target.value),
                            },
                          }));
                        }}
                      >
                        <option>Selecione</option>
                        {optionalCoverages
                          ?.filter((i) => i.type === 'damages_morais')
                          ?.map((item, index) => (
                            <option key={index} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                      </Select>
                    )}
                  </CoveragesArea>
                )}

                {products?.length > 0 && (
                  <h3 style={{ marginTop: 15 }}>
                    Produtos
                    <IconButton
                      size="small"
                      style={{ marginLeft: 10 }}
                      onClick={() => setToogleSections({ ...toogleSections, product: !toogleSections.product })}
                    >
                      {toogleSections?.product ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                    </IconButton>
                  </h3>
                )}

                {toogleSections?.product && (
                  <CoveragesArea style={{ marginTop: -10 }}>
                    {products?.filter((i) => i.charge_type === 'unique')?.length > 0 && (
                      <ProductsList>
                        <Select
                          label="Produtos únicos"
                          height="35px"
                          width="400px"
                          value={''}
                          onChange={(e) => {
                            const selectedProduct = products?.find((i) => i.id === +e.target.value);
                            setSelectedProducts((prev) => [...prev, selectedProduct]);
                          }}
                        >
                          <option value="" disabled selected>
                            Selecione
                          </option>
                          {products
                            ?.filter(
                              (product) =>
                                product.charge_type === 'unique' &&
                                !selectedProducts?.find((selectedProduct) => selectedProduct?.id === product.id),
                            )
                            ?.map((item, index) => (
                              <option key={index} value={item?.id}>
                                {item?.name}
                              </option>
                            ))}
                        </Select>

                        {selectedProducts
                          ?.filter((product) => product.charge_type === 'unique')
                          ?.map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ marginRight: 12, fontSize: 13 }}>{item?.name}</p>
                              {!item.applied_automatic && (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSelectedProducts((prev) =>
                                      prev.filter((selectedProduct) => selectedProduct?.id !== item?.id),
                                    );
                                  }}
                                >
                                  <FiTrash size={16} />
                                </IconButton>
                              )}
                            </div>
                          ))}
                      </ProductsList>
                    )}

                    {products?.filter((i) => i.charge_type === 'periodic')?.length > 0 && (
                      <ProductsList>
                        <Select
                          label="Produtos recorrentes"
                          height="35px"
                          width="400px"
                          value={''}
                          onChange={(e) => {
                            const selectedProduct = products?.find((i) => i.id === +e.target.value);
                            setSelectedProducts((prev) => [...prev, selectedProduct]);
                          }}
                        >
                          <option value="" disabled selected>
                            Selecione
                          </option>
                          {products
                            ?.filter(
                              (product) =>
                                product.charge_type === 'periodic' &&
                                !selectedProducts?.find((selectedProduct) => selectedProduct?.id === product.id),
                            )
                            ?.map((item, index) => (
                              <option key={index} value={item?.id}>
                                {item?.name}
                              </option>
                            ))}
                        </Select>

                        {selectedProducts
                          ?.filter((product) => product.charge_type === 'periodic')
                          ?.map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ marginRight: 12, fontSize: 13 }}>{item?.name}</p>
                              {!item.applied_automatic && (
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSelectedProducts((prev) =>
                                      prev.filter((selectedProduct) => selectedProduct?.id !== item?.id),
                                    );
                                  }}
                                >
                                  <FiTrash size={16} />
                                </IconButton>
                              )}
                            </div>
                          ))}
                      </ProductsList>
                    )}
                  </CoveragesArea>
                )}

                {(sliderHandle.handle || useRangeSlider) && (
                  <>
                    <h3 style={{ marginTop: 25 }}>
                      Desconto e agravo
                      <IconButton
                        size="small"
                        style={{ marginLeft: 10 }}
                        onClick={() => setToogleSections({ ...toogleSections, discount: !toogleSections.discount })}
                      >
                        {toogleSections?.discount ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                      </IconButton>
                    </h3>
                    {toogleSections?.discount && (
                      <CoveragesArea style={{ marginTop: -10 }}>
                        <CommissionSlider
                          grievance_percent={sliderHandle.grievance_percent}
                          min_grievance_percent={sliderHandle.min_grievance_percent}
                          max_grievance_percent={sliderHandle.max_grievance_percent}
                          setPercentCommission={setPercentCommission}
                          useRangeSlider={useRangeSlider}
                          percentCommission={percentCommission}
                        />
                      </CoveragesArea>
                    )}
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </OptionsSide>
        )}

        {!loading && (
          <VehicleDataSide>
            <SideBar
              type="quotation"
              confirmButtonHandleClick={() => {
                handleSubmit();
                // nextStep();
              }}
              nextStep={() => nextStep()}
              hasChange={hasChange}
              setQuotationData={setQuotationData}
              sliderHandle={sliderHandle?.handle}
              setHasChange={setHasChange}
              quotationData={quotationData}
              dataCoverage={dataCoverage}
              quotationResponse={quotationResponse}
              setQuotationResponse={setQuotationResponse}
              percentCommission={percentCommission}
              setPercentCommission={setPercentCommission}
              percentDiscount={percentDiscount}
              grievance_percent={sliderHandle.grievance_percent}
              min_grievance_percent={sliderHandle.min_grievance_percent}
              max_grievance_percent={sliderHandle.max_grievance_percent}
              discount_percent={sliderHandle.discount_percent}
              haveAddress={false}
              haveCoverages={false}
              confirmButtonCollor="#fe9501"
              confirmButtonBoxShadowColor="#ff9500"
              proposalResponse={proposalResponse}
              selectedProducts={selectedProducts}
              handleProducts={handleProducts}
              getPartnerProducts={getPartnerProducts}
              useRangeSlider={useRangeSlider}
              installments={installments}
              selectedInstallmentOption={selectedInstallmentOption}
              shouldUseAnnualInstallments={shouldUseAnnualInstallments}
              onQuotationCalculationStateChange={setQuotationCalculationState}
              canCalculateQuotation={!policyModalitiesLoading}
              requiresBasicCoverage={requiresBasicCoverage}
            />
          </VehicleDataSide>
        )}
      </Content>
    </Container>
  );
};

export default CoverageStep;
